import { render } from "./eye_procedures.vue?vue&type=template&id=1facf731&scoped=true"
import script from "./eye_procedures.vue?vue&type=script&lang=js"
export * from "./eye_procedures.vue?vue&type=script&lang=js"

import "./eye_procedures.vue?vue&type=style&index=0&id=1facf731&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1facf731"]])

export default __exports__